export default {
    search: 'חפש',
    associate: 'קשרי פאה ממלאי',
}
